/**
 * 所有类的基类
 */
export class BaseObject {
}
